/*!
 * Copyright © 2020-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Type } from '@angular/core';

import { ELazyModules } from '../core/models';

const lazyModules: { name: string; loadChildren: () => Promise<Type<any>> }[] = [
  {
    name: ELazyModules.External,
    loadChildren: () => import('../external/external.module').then(m => m.ExternalModule)
  },
  {
    name: ELazyModules.VehicleDriverPanel,
    loadChildren: () => import('../vehicle-driver-panel').then(m => m.VehicleDriverPanelModule)
  },
  {
    name: ELazyModules.OverlayControls,
    loadChildren: () => import('../overlay-controls').then(m => m.OverlayControlsModule)
  },
  {
    name: ELazyModules.MapOptions,
    loadChildren: () => import('../map-options').then(m => m.MapOptionsModule)
  },
  {
    name: ELazyModules.Replay,
    loadChildren: () => import('../replay').then(m => m.ReplayModule)
  }
];

export function configureLazyLoader(): { [key: string]: () => Promise<Type<any>> } {
  const result: { [key: string]: () => Promise<Type<any>> } = {};
  for (const w of lazyModules) {
    result[w.name] = w.loadChildren;
  }
  return result;
}
